export default __webpack_public_path__ + "static/media/landscape17.ed44c27f.jpg";